// import AsyncCreateableSelect from "./AsyncCreatableSelect";
import Select from "./Select";
import { useCollection } from "@nandorojo/swr-firestore";
import { Loader } from "react-bulma-components";

const TagSelect = ({
  value = [],
  isCreatable = true,
  isClearable = true,
  ...props
}) => {
  const tagsData = useCollection("tags", {
    orderBy: ["name", "asc"]
  });

  const tagOptions = tagsData?.data?.map(tag => ({
    label: tag.name,
    value: tag.name
  }));
  return tagsData.loading ? (
    <Loader />
  ) : (
    <Select
      options={tagOptions}
      isMulti={true}
      isCreatable={isCreatable}
      isClearable={isClearable}
      value={value}
      {...props}
    />
  );
};

export default TagSelect;
